import { queryOptions, useMutation } from '@tanstack/react-query'
import { request } from '@/shared/api'
import {
  type BookingConfirmation,
  BookingConfirmationSchema,
  type PublicBookingInput,
  type PublicExcursion,
  PublicExcursionSchema,
} from '../model/schema'

/**
 * Анонимный контур: cookie сессии не отправляется намеренно (`anonymous: true`),
 * иначе вошедший сотрудник получил бы на публичной странице расширенный ответ
 * и не заметил бы, что она отдаёт лишнее.
 */
export function publicExcursionQueryOptions(excursionId: string, token: string) {
  return queryOptions({
    queryKey: ['public-excursion', excursionId, token] as const,
    queryFn: (): Promise<PublicExcursion> =>
      request(`/public/excursions/${excursionId}`, PublicExcursionSchema, {
        anonymous: true,
        query: { token },
      }),
    // Битая ссылка не чинится повтором, а лишние попытки помогают перебирать.
    retry: false,
    staleTime: 60_000,
  })
}

export function usePublicBookingMutation() {
  return useMutation({
    mutationFn: ({
      excursionId,
      token,
      consentGiven,
      ...rest
    }: PublicBookingInput): Promise<BookingConfirmation> =>
      request(`/public/excursions/${excursionId}/bookings`, BookingConfirmationSchema, {
        method: 'POST',
        anonymous: true,
        query: { token },
        body: { ...rest, consent_given: consentGiven },
      }),
  })
}
